import axios from "axios";
// import {provide} from 'vue';
// import { inject} from 'vue';
import store from "@/store";
export const LOGIN_INFO_MSG_TOKEN_UNAUTHORIZED =
  "Your session has expired. Please sign in to pick up where you left off.";
const urlWithProtocol = new RegExp("^https?://");
export const UIM_MS_SSO_KEY = "ms-sso";
export const LOGIN_URL = process.env.VUE_APP_LOGIN_URL;
export const API_URL = process.env.VUE_APP_UIM_HOST;

/** Logout api */
export function logoutUim(successUrl) {
  if (!successUrl) {
    throw new Error("successUrl is required.");
  }

  if (!(successUrl instanceof URL)) {
    throw new Error("successUrl should be an instance of URL.");
  }

  const logoutUrl = new URL(process.env.VUE_APP_LOGOUT_URL);
  window.location.href = logoutUrl;
}

export function getUIMHost() {
  return getUIMUrl(process.env);
}

export function getUIMUrl(env) {
  if (env.VUE_APP_UIM_HOST) {
    let host = env.VUE_APP_UIM_HOST;
    if (!urlWithProtocol.test(host)) {
      host = "https://" + host;
    }
    return host;
  } else {
    throw new Error("Missing environment variable: VUE_APP_UIM_HOST");
  }
}

export function validateUser() {
  let url = process.env.VUE_APP_BACKEND_API + `validateBackend`;
  let headers = {
    "Content-Type": "application/json",
  };
  return axios
    .post(url, {}, { headers: headers, withCredentials: true })
    .then((response) => {
      console.log(JSON.stringify(response));
      // alert("from validateUser response =" + JSON.stringify(response));
      // alert(response.data[0].email)
      store.methods.setUser(response.data[0].email);
      // alert('userRole=',response.data[0].email)
      store.methods.setUserRole(response.data[0].user_role);
      let group = [];
      for (let i = 0; i < response.data.length; i++) {
        group.push(response.data[i].group_name);
      }
      // alert(group)

      store.methods.setGroup(group);
      if (response && response.status === 200) {
        return response;
      } else {
        return {};
      }
    });
}

export function redirectToCreditLogin(successUrl) {
  if (!successUrl) {
    throw new Error("successUrl is required.");
  }
  if (!(successUrl instanceof URL)) {
    throw new Error("successUrl should be an instance of URL.");
  }

  successUrl = new URL(window.location.href);
  const loginUrl = new URL(LOGIN_URL);
  loginUrl.searchParams.append("targetUrl", successUrl);
  window.location.href = loginUrl;
}

export function validatePath(role, path, group) {
  var mapExist = false;
  const rolePathMap = [
    { path: "/RegisterUser", role: "admin", group: "NON_CRS" },
    { path: "/report", role: "admin", group: "NON_CRS" },
    { path: "/", role: "admin", group: "NON_CRS" },
    { path: "/feed-back", role: "admin", group: "NON_CRS" },
    { path: "/usfeedbackform", role: "admin", group: "NON_CRS" },
    { path: "/usfeedbackform", role: "user", group: "NON_CRS" },
    { path: "/", role: "user", group: "NON_CRS" },
    { path: "/feed-back", role: "user", group: "NON_CRS" },
    { path: "/", role: "restricted admin internal", group: "NON_CRS" },
    { path: "/feed-back", role: "restricted admin internal", group: "NON_CRS" },
    { path: "/report", role: "restricted admin internal", group: "NON_CRS" },
    { path: "/dashboard", role: "restricted admin internal", group: "NON_CRS" },
    {
      path: "/usfeedbackform",
      role: "restricted admin internal",
      group: "NON_CRS",
    },
    { path: "/dashboard", role: "admin", group: "NON_CRS" },
    { path: "/report", role: "restricted admin external", group: "NON_CRS" },
    { path: "/dashboard", role: "restricted admin external", group: "NON_CRS" },
    {
      path: "/feedbackStatus",
      role: "restricted admin external",
      group: "NON_CRS",
    },
    { path: "/feedbackStatus", role: "admin", group: "NON_CRS" },
    { path: "/feedbackStatus", role: "user", group: "NON_CRS" },
    {
      path: "/feedbackStatus",
      role: "restricted admin internal",
      group: "NON_CRS",
    },

    { path: "/rca", role: "restricted admin external", group: "NON_CRS" },
    { path: "/rca", role: "admin", group: "NON_CRS" },
    { path: "/rca", role: "restricted admin internal", group: "NON_CRS" },

    //CRS
    { path: "/CRS/mumbai", role: "admin", group: "CRS" },
    { path: "/CRS/", role: "admin", group: "CRS" },
    { path: "/CRS/", role: "user", group: "CRS" },
    { path: "/CRS/mumbai", role: "user", group: "CRS" },
    { path: "/CRS/usfeedbackform", role: "admin", group: "CRS" },
    { path: "/CRS/usfeedbackform", role: "user", group: "CRS" },
    { path: "/CRS/report", role: "admin", group: "CRS" },
    { path: "/CRS/RegisterUser", role: "admin", group: "CRS" },
    { path: "/CRS/dashboard", role: "admin", group: "CRS" },
    { path: "/CRS/dashboard", role: "restricted admin internal", group: "CRS" },
    {
      path: "/CRS/usfeedbackform",
      role: "restricted admin internal",
      group: "CRS",
    },
    { path: "/CRS/mumbai", role: "restricted admin internal", group: "CRS" },
    { path: "/CRS/report", role: "restricted admin internal", group: "CRS" },
    { path: "/", role: "restricted admin internal", group: "CRS" },
    { path: "/CRS/", role: "restricted admin internal", group: "CRS" },
    { path: "/CRS/report", role: "restricted admin external", group: "CRS" },
    { path: "/CRS/dashboard", role: "restricted admin external", group: "CRS" },
    {
      path: "/CRS/feedbackStatus",
      role: "restricted admin external",
      group: "CRS",
    },
    { path: "/CRS/feedbackStatus", role: "admin", group: "CRS" },
    {
      path: "/CRS/feedbackStatus",
      role: "restricted admin internal",
      group: "CRS",
    },
    { path: "/CRS/feedbackStatus", role: "user", group: "CRS" },
  ];
  if (role != "" && path != "") {
    mapExist = rolePathMap.some(
      (el) => el.role === role && el.path === path && el.group === group,
    );
  }
  return mapExist;
}
